module.exports = __webpack_public_path__ + "img/original-logo.b5f1bff7.svg";